<template>
    <div>
        <b-row v-if="tipo==1" align-h="center">
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="6">
                <b-alert show variant="warning" class="p-1 pl-4">
                    <b-row align-v="center">
                        <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                            <b-card-text>
                                Parametro de Busqueda
                            </b-card-text>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4"	lg="4"	xl="6">
                            <input v-model="receptor" @keyup.enter="listPagadas()" class="form-control input-dark" placeholder="Busqueda por RUC" /> 
                        </b-col>
                        <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                            <div class="text-center">
                                <b-button href="#" :disabled="checkPagadas()" variant="primary" @click="listPagadas()">Buscar <i class="fa fa-user"></i></b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-alert>
            </b-col>
        </b-row>
        <template v-if="cargando">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h3>Buscando <i class="fa fa-spin fa-spinner"></i></h3>
                </div>
            </div>
        </template>
        <template v-if="consolidadosxpagar.length>0 || consolidadospagados.length>0">
            <template v-if="!cargando">
                <template v-if="receiver">
                    <b-row>
                        <b-col cols="12" sm="4"	md="4"	lg="1"	xl="1">
                            <b>{{ receiver.idReceptor }}</b>
                        </b-col>    
                        <b-col cols="12" sm="8"	md="8"	lg="11"	xl="11">
                            <b>{{ receiver.razonSocial }}</b>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                            {{ receiver.direccionReferencia }}
                        </b-col>
                    </b-row>
                </template>
            </template>
            <hr>
            <b-row>
                <b-col cols="12" sm="6"	md="10"	lg="10"	xl="10">
                    <h6 class="ml-4"><em><b>Deudas Pendientes</b></em></h6> 
                </b-col>
            </b-row>
            <b-table 
                class="mt-1"
                striped 
                hover
                small 
                :busy="busy"
                :items="consolidadosxpagar" 
                :fields="consolidados_fields"
                >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
                <template slot="antiguedad" slot-scope="row">
                    <i v-if="row.item.morosidad === 1" class="fa fa-smile fa-2x text-success"></i>
                    <i v-else-if="row.item.morosidad === 2" class="fa fa-meh fa-2x text-warning"></i>
                    <i v-else-if="row.item.morosidad === 3" class="fa fa-frown fa-2x text-danger"></i>
                </template>
                <template slot="emision" slot-scope="row">
                    {{ row.item.fechaEmision | moment('D/M/Y') }}
                </template>
                <template slot="vencimiento" slot-scope="row">
                    {{ row.item.vencimiento | moment('D/M/Y') }}
                </template>
                <template slot="numOperacion" slot-scope="row">
                   <template>
                       <div v-if="row.item && row.item.creditdocumentpay && row.item.creditdocumentpay != ''">
                            {{ row.item.creditdocumentpay[0].numeroOperacion }}
                       </div>
                   </template>
                </template>
                <template slot="fechaPago" slot-scope="row">
                   <template>
                       <div v-if="row.item && row.item.creditdocumentpay && row.item.creditdocumentpay != ''">
                            {{ row.item.creditdocumentpay[0].fechaPago | moment('D/M/Y')}}
                       </div>
                   </template>
                </template>
                <template slot="tiempo" slot-scope="row">
                    <div>
                        {{ row.item.fechaEmision | moment('from') }}
                    </div>
                </template>
                <template slot="deudatotalSoles" slot-scope="row">
                    <div v-if="row.item.importeTotalSoles > 0">
                        S/ {{row.item.importeTotalSoles.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="parcialsoles" slot-scope="row">
                    <div v-if="row.item.importePagadoSoles > 0">
                        S/ {{row.item.importePagadoSoles.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadasoles" slot-scope="row">
                    <div v-if="row.item.importeTotalSoles-row.item.importePagadoSoles > 0">
                        S/ {{(row.item.importeTotalSoles-row.item.importePagadoSoles).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudatotalDolares" slot-scope="row">
                    <div v-if="row.item.importeTotalDolares > 0">
                        $ {{row.item.importeTotalDolares.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="parcialdolares" slot-scope="row">
                    <div v-if="row.item.importePagadoDolares > 0">
                        $ {{row.item.importePagadoDolares.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadaDolares" slot-scope="row">
                    <div v-if="row.item.importeTotalDolares-row.item.importePagadoDolares > 0">
                        $ {{(row.item.importeTotalDolares-row.item.importePagadoDolares).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="acciones" slot-scope="row">
                    <div>
                        <b-button v-show="!row.item.loading" variant="light" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                            <template v-if="!row.item.mostrardetalles">
                                <i class="fa fa-plus"></i>
                            </template>
                            <template v-else>
                                <i class="fa fa-minus"></i>
                            </template>
                        </b-button>
                        <b-button size="sm" v-b-modal.sendfacturaemail1 v-b-tooltip.hover title="Enviar por Email@" @click="setTicket(row.item)" class="fa fa-envelope ml-2"></b-button>
                        <b-button size="sm" v-b-modal.prevmodal v-b-tooltip.hover title="Vista Previa" @click="viewPdf(row.item)" class="ml-2"><i class="fa fa-tv"></i></b-button>
                        <b-button size="sm" v-b-modal.registropago1 v-b-tooltip.hover variant="success" class="ml-2" @click="getDocumento(row, 1)" title="Registrar pago"><i class="fa fa-money-bill-alt"></i></b-button>
                        <b-button size="sm" v-b-modal.listarpagos v-b-tooltip.hover variant="primary" class="ml-2" @click="getDocumento(row, 2)" title="Listar Pagos"><i class="fa fa-eye"></i></b-button>
                    </div>
                </template>
                <template slot="row-details" slot-scope="row">
                    <b-card class="tamanioletra">
                        <b-table striped hover :items="row.item.detalles" :fields="listaitems_fields">
                        <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                        <template slot="cantidad" slot-scope="row">
                            <div>{{ Number.parseFloat(row.item.cantidad).toFixed(2) }}</div>
                        </template>
                        <template slot="baseAfectacionIgv" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template
                                v-if="row.item.precioVentaUnitario"
                            >{{ Number.parseFloat(row.item.baseAfectacionIgv).toFixed(2) }}</template>
                            </div>
                        </template>
                        <template slot="montoAfectacionIgv" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template
                                v-if="row.item.precioVentaUnitario"
                            >{{ Number.parseFloat(row.item.montoAfectacionIgv).toFixed(2) }}</template>
                            </div>
                        </template>
                        <template slot="descuento" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.descuento">
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            </div>
                        </template>
                        <template slot="valorVenta" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.tipoAfectacionIgv=='10'">            
                                {{ Number.parseFloat(row.item.valorVenta*($store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) }}
                            </template>
                            <template v-else-if="row.item.tipoAfectacionIgv=='20' || row.item.tipoAfectacionIgv=='30'">
                                {{ Number.parseFloat(row.item.valorVenta).toFixed(2) }}
                            </template>
                            </div>
                        </template>
                        </b-table>
                    </b-card>
                    </template>
            </b-table>
            <div class="row">
                <div class="col-md-6">
                    <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                </div>
                <div class="col-md-6">
                    <div class="float-right">
                    <b-pagination
                        size="sm"
                        :total-rows="total"
                        v-model="currentPage"
                        @input="listPagadas"
                        :per-page="limit"
                    ></b-pagination>
                    </div>
                </div>
            </div>
            <b-row>
                <b-col cols="12" sm="6"	md="10"	lg="10"	xl="10">
                    <h6 class="ml-4"><em><b>Pagos Realizados</b></em></h6> 
                </b-col>
            </b-row>
            <b-table 
            :tbody-tr-class="rowClass"
                class="mt-1"
                hover
                small 
                :busy="busy"
                :items="consolidadospagados" 
                :fields="consolidados_fields"
                >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
                <template slot="antiguedad" slot-scope="row">
                    <i v-if="row.item.morosidad === 1" class="fa fa-smile fa-2x text-success"></i>
                    <i v-else-if="row.item.morosidad === 2" class="fa fa-meh fa-2x text-warning"></i>
                    <i v-else-if="row.item.morosidad === 3" class="fa fa-frown fa-2x text-danger"></i>
                </template>
                <template slot="emision" slot-scope="row">
                    {{ row.item.fechaEmision | moment('D/M/Y') }}
                </template>
                <template slot="vencimiento" slot-scope="row">
                    {{ row.item.vencimiento | moment('D/M/Y') }}
                </template>
                <template slot="numOperacion" slot-scope="row">
                    <template>
                       <div v-if="row.item && row.item.creditdocumentpay && row.item.creditdocumentpay != ''">
                            {{ row.item.creditdocumentpay[0].numeroOperacion }}
                       </div>
                   </template>
                </template>
                <template slot="fechaPago" slot-scope="row">
                    <template>
                       <div v-if="row.item && row.item.creditdocumentpay && row.item.creditdocumentpay != ''">
                            {{ row.item.creditdocumentpay[0].fechaPago | moment('D/M/Y')}}
                       </div>
                   </template>
                </template>
                <template slot="tiempo" slot-scope="row">
                    <div>
                        {{ row.item.fechaEmision | moment('from') }}
                    </div>
                </template>
                <template slot="deudatotalSoles" slot-scope="row">
                    <div v-if="row.item.importeTotalSoles > 0">
                        S/ {{row.item.importeTotalSoles.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="parcialsoles" slot-scope="row">
                    <div v-if="row.item.importePagadoSoles > 0">
                        S/ {{row.item.importePagadoSoles.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadasoles" slot-scope="row">
                    <div v-if="row.item.importeTotalSoles-row.item.importePagadoSoles > 0">
                        S/ {{(row.item.importeTotalSoles-row.item.importePagadoSoles).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudatotalDolares" slot-scope="row">
                    <div v-if="row.item.importeTotalDolares > 0">
                        $ {{row.item.importeTotalDolares.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="parcialdolares" slot-scope="row">
                    <div v-if="row.item.importePagadoDolares > 0">
                        $ {{row.item.importePagadoDolares.toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="deudapagadaDolares" slot-scope="row">
                    <div v-if="row.item.importeTotalDolares-row.item.importePagadoDolares > 0">
                        $ {{(row.item.importeTotalDolares-row.item.importePagadoDolares).toFixed(2)}}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template slot="acciones" slot-scope="row">
                    <div>
                        <b-button v-show="!row.item.loading" variant="light" size="sm" @click="mostrarDetallesPagados(row, row.index)" title="Mas opciones">
                            <template v-if="!row.item.mostrarDetallesPagados">
                                <i class="fa fa-plus"></i>
                            </template>
                            <template v-else>
                                <i class="fa fa-minus"></i>
                            </template>
                        </b-button>
                        <b-button size="sm" v-b-modal.prevmodal v-b-tooltip.hover title="Vista Previa" @click="viewPdf(row.item)"><i class="fa fa-tv"></i></b-button>
                        <b-button size="sm" v-b-modal.registropago1 v-b-tooltip.hover variant="success" class="ml-2" @click="getDocumento(row, 1)" title="Registrar pago"><i class="fa fa-money-bill-alt"></i></b-button>
                        <b-button size="sm" v-b-modal.listarpagos v-b-tooltip.hover variant="primary" class="ml-2" @click="getDocumento(row, 2)" title="Listar Pagos"><i class="fa fa-eye"></i></b-button>
                    </div>
                </template>
                <template slot="row-details" slot-scope="row">
                    <b-card class="tamanioletra">
                        <b-table striped hover :items="row.item.detalles" :fields="listaitems_fields">
                        <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                         <template slot="cantidad" slot-scope="row">
                            <div>{{ Number.parseFloat(row.item.cantidad).toFixed(2) }}</div>
                        </template>
                        <template slot="baseAfectacionIgv" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template
                                v-if="row.item.precioVentaUnitario"
                            >{{ Number.parseFloat(row.item.baseAfectacionIgv).toFixed(2) }}</template>
                            </div>
                        </template>
                        <template slot="montoAfectacionIgv" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template
                                v-if="row.item.precioVentaUnitario"
                            >{{ Number.parseFloat(row.item.montoAfectacionIgv).toFixed(2) }}</template>
                            </div>
                        </template>
                        <template slot="descuento" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.descuento">
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            </div>
                        </template>
                        <template slot="valorVenta" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.tipoAfectacionIgv=='10'">            
                                {{ Number.parseFloat(row.item.valorVenta*($store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) }}
                            </template>
                            <template v-else-if="row.item.tipoAfectacionIgv=='20' || row.item.tipoAfectacionIgv=='30'">
                                {{ Number.parseFloat(row.item.valorVenta).toFixed(2) }}
                            </template>
                            </div>
                        </template>
                        </b-table>
                    </b-card>
                </template>
            </b-table>
        </template>
        <template v-else-if="tipo==2">
            <b-alert show variant="warning" class="text-center">No se encontro información para esta cuenta</b-alert>
        </template>
        <b-modal id="registropago1" size="lg" title="Registrar Pago" v-model="registrarpago">
                <div role="group">
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-alert v-if="Object.keys(filaActual).length != 0" show variant="warning" class="text-center"><b>Cliente: </b> {{ filaActual.item.receiver.idReceptor }}-{{ filaActual.item.receiver.razonSocial }}</b-alert>
                        <b-table striped hover :items="[filaActual.item]" :fields="detallepagos_fields">
                            <template slot="serie" slot-scope="row">
                                {{ row.item.serie }}
                            </template>
                            <template slot="numero" slot-scope="row">
                                {{ row.item.numero }}
                            </template>
                            <template slot="totalsoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles > 0">
                                    S/ {{ row.item.importeTotalSoles.toFixed(2) }}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="pagadosoles" slot-scope="row">
                                <div v-if="row.item.importeTotalSoles-row.item.importePagadoSoles > 0">
                                    S/ {{(row.item.importeTotalSoles-row.item.importePagadoSoles).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="totaldolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares > 0">
                                    US$ {{ row.item.importeTotalDolares.toFixed(2) }}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                            <template slot="pagadodolares" slot-scope="row">
                                <div v-if="row.item.importeTotalDolares-row.item.importePagadoDolares > 0">
                                    US$ {{(row.item.importeTotalDolares-row.item.importePagadoDolares).toFixed(2)}}
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                        </b-table>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                            <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                {{ fpago.nombre }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="tipodemoneda" disabled>
                            <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                {{ moneda.descripcion }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <div v-if="cargandoBancos" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Cargando...</strong>
                        </div>
                        <template v-else>
                            <div>
                                <b-form-select v-model="banco" class="mb-3" >
                                <template v-slot:first>
                                    <option :value="null" disabled>-- Selecciona una cuenta --</option>
                                </template>
                                <option v-for="banco in listaBancos" :value="banco" :key="banco.numeroCuenta">{{ banco.banco }} / {{ banco.moneda }} / {{ banco.numeroCuenta }} / {{ banco.cci }}</option>
                                </b-form-select>
                            </div>
                        </template>
                    </b-col>
                </b-row>
                <b-row class="mb-3 text-center" v-if="listaBancos.length === 0 && formadepago.codigo != '000'">
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-badge variant="warning">No se encontro informacion de bancos, por favor diríjase al perfil de administrador para agregarlos</b-badge>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <b-form-input v-model="importe" type="text" :value="pago.importePagado" placeholder="Importe"></b-form-input>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <b-form-input v-model="numerooperacion" type="text" placeholder="Nro. operación"></b-form-input>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <datepicker v-model="fpago" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-form-textarea
                            v-model="observaciones"
                            placeholder="Observaciones..."
                            rows="3"
                            max-rows="12"
                        ></b-form-textarea>
                    </b-col>
                </b-row>
                </div>
                <div slot="modal-footer" class="w-100">
                    <div v-if="nivelusuario">      
                    <b-btn v-if="!sendpago" :disabled="validFormularioPago()" size="sm" class="float-right" variant="primary" @click="pagoDeuda(1)">
                        Registrar
                    </b-btn>
                    <b-btn v-else size="sm" class="float-right" variant="secondary">
                        <i class="fa fa-spin fa-spinner"></i> Registrando ...
                    </b-btn>
                     </div>
                </div>
            </b-modal>
<!--Email-->
        <b-modal id="sendfacturaemail1" title="Enviar por Correo" v-model="previacorreo">
      <div role="group">
        <label for="inputLive">Correos:</label>
        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail(ticket)"></b-form-input>
        <b-form-text
          style="font-size: small !important; color: #ea0909 !important"
        >Ingresa un correo ó varios separados por comas (,)</b-form-text>
      </div>
      <b-btn
          v-if="!sendcorreo"
          size="sm"
          class="float-right"
          variant="primary"
          @click="sendMail(ticket)"
        >Enviar</b-btn>
        <b-btn v-else size="sm" class="float-right" variant="secondary">
          <i class="fa fa-spin fa-spinner"></i> Enviando...
        </b-btn>
        <hr class="mt-5">
        <h5>Correos en módulo Negocios:</h5>
        <h5><li style="list-style:none" class="mr-1" variant="dark" v-for="(item,index) in reciveEmail" :key="index">
        <b-badge pill variant="light">{{item}}
        <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
        </li>
        </h5>
        <b-button v-if="recipients!=''" :disabled="mostraremail" class="float-right" size="sm" @click="enviarEmail(ticket)" variant="primary">Enviar a todos</b-button>
        <b-button v-else class="float-right" :disabled="mostraremail" size="sm" @click="enviarEmail(ticket)" variant="primary">Enviar</b-button>
         <div slot="modal-footer"></div>
    </b-modal>
<!--Fin Email-->
        <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previewmodal">
                <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
                <template v-else>
                <template v-if="pdfobject !==''">
                    <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                </template>
                </template>
            </b-modal>
        <b-modal id="listarpagos" size="lg" v-model="listarpagos">
            <template slot="modal-title">
                {{ titlepagos }}
            </template>
            <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                    <b-alert v-if="Object.keys(filaActual).length != 0" show variant="warning" class="text-center"><b>Cliente: </b> {{ filaActual.item.receiver.idReceptor }}-{{ filaActual.item.receiver.razonSocial }}</b-alert>
                    <b-table striped hover :items="[filaActual.item]" :fields="detallepagos_fields">
                        <template slot="serie" slot-scope="row">
                            {{ row.item.serie }}
                        </template>
                        <template slot="numero" slot-scope="row">
                            {{ row.item.numero }}
                        </template>
                        <template slot="totalsoles" slot-scope="row">
                            <div v-if="row.item.importeTotalSoles > 0">
                                S/ {{ row.item.importeTotalSoles.toFixed(2) }}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </template>
                        <template slot="pagadosoles" slot-scope="row">
                            <div v-if="row.item.importeTotalSoles-row.item.importePagadoSoles > 0">
                                S/ {{(row.item.importeTotalSoles-row.item.importePagadoSoles).toFixed(2)}}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </template>
                        <template slot="totaldolares" slot-scope="row">
                            <div v-if="row.item.importeTotalDolares > 0">
                                US$ {{ row.item.importeTotalDolares.toFixed(2) }}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </template>
                        <template slot="pagadodolares" slot-scope="row">
                            <div v-if="row.item.importeTotalDolares-row.item.importePagadoDolares > 0">
                                US$ {{(row.item.importeTotalDolares-row.item.importePagadoDolares).toFixed(2)}}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </template>
                    </b-table>
                </b-col>
            </b-row><br>
            <div v-if="!editando">
                <b-alert align="center" variant="warning" show>Pagos</b-alert>
                <b-table :fields="pagos_fields" :items="listaPagos" :busy="cargandopagos">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template v-if="row.item && row.item.registrador && row.item.registrador !=''" slot="registrador" slot-scope="row">
                        {{row.item.registrador.nomUsuario}} {{row.item.registrador.appUsuario}}
                    </template>
                    <template slot="fregistro" slot-scope="row">
                        {{ row.item.created_at | moment('D/M/Y') }}
                    </template>
                    <template slot="fpago" slot-scope="row">
                        {{ row.item.fechaPago | moment('D/M/Y') }}
                    </template>
                    <template slot="importe" slot-scope="row">
                        <template v-if="row.item.tipoMoneda == 'PEN'">
                            S/ {{ row.item.importePagado }}
                        </template>
                        <template v-else-if="row.item.tipoMoneda == 'USD'">
                            $ {{ row.item.importePagado }}
                        </template>
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <b-button-group>
                            <b-button size="sm" @click="row.toggleDetails">
                            {{ row.detailsShowing ? '-' : '+' }}
                            </b-button>
                            <div v-if="nivelusuario">
                                <b-button size="sm" variant="primary" @click="editPago(row)"><i class="fa fa-pen"></i></b-button>
                                <b-button size="sm" variant="danger" @click="deletePago(row)"><i class="fa fa-trash"></i></b-button>
                            </div>                  
                        </b-button-group>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card>
                            <b-row>
                                <b-col cols="12">
                                    <b-row>
                                        <b-col>
                                            <b>Observaciones:</b>
                                        </b-col>
                                        <b-col>
                                            <b>Número de Cuenta:</b>
                                        </b-col>
                                        <b-col>
                                            <b>Número de Operación:</b>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            {{ row.item.observaciones }}
                                        </b-col>
                                        <b-col v-if="row.item.infoBanco && row.item.infoBanco.numeroCuenta">
                                            {{ row.item.infoBanco.numeroCuenta }}
                                        </b-col>
                                        <b-col>
                                            {{ row.item.numeroOperacion }}
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>    
                        </b-card>
                    </template>
                </b-table>               
            </div>
            <div v-else>
                <b-row>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                            <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                {{ fpago.nombre }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" disabled v-model="tipodemoneda">
                            <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                {{ moneda.descripcion }}
                            </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4">
                        <b-form-input v-model="importe" type="text" placeholder="Importe"></b-form-input>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" v-if="pago.infoBanco && editbank">
                        <b-input-group>
                            <b-form-input class="input-placedark input-dark" :placeholder="pago.infoBanco.banco+' / '+pago.infoBanco.moneda+' / '+pago.infoBanco.numeroCuenta+' / '+pago.infoBanco.cci"></b-form-input>
                            <b-input-group-text slot="append">
                                <button class="btn btn-warning btn-sm p-0 pl-1 pr-1 sinresultados" @click="editBank()"><i class="fa fa-pencil-alt"></i></button>
                            </b-input-group-text>
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" v-else>
                        <b-row>
                            <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                                <div v-if="cargandoBancos" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong> Cargando...</strong>
                                </div>
                                <template v-else>
                                    <div>
                                        <b-form-select v-model="banco" class="mb-3" >
                                        <template v-slot:first>
                                            <option :value="null" disabled>-- Selecciona una cuenta --</option>
                                        </template>
                                        <option v-for="banco in listaBancos" :value="banco" :key="banco.numeroCuenta">{{ banco.banco }} / {{ banco.moneda }} / {{ banco.numeroCuenta }} / {{ banco.cci }}</option>
                                        </b-form-select>
                                    </div>
                                </template>
                            </b-col>
                            <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                                <b-form-input v-model="numerooperacion" type="text" placeholder="Nro. operación"></b-form-input>
                            </b-col>
                            <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                                <datepicker v-model="fpago" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row><br>
                <b-row v-if="pago.infoBanco && editbank">
                    <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <b-form-input v-model="numerooperacion" type="text" placeholder="Nro. operación"></b-form-input>
                    </b-col>
                    <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <datepicker v-model="fpago" :format="customFormatter" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-form-textarea
                            v-model="observaciones"
                            placeholder="Observaciones..."
                            rows="3"
                            max-rows="12"
                        ></b-form-textarea>
                    </b-col>
                </b-row>
            </div>
            <div>
                <div v-if="ncpagos.length != 0">
                     <b-alert align="center" variant="danger" show>{{ncpagos[0].observaciones}}</b-alert> 
               
                <b-table :items="ncpagos" :fields="pagos_fields2">
                        <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template v-if="row.item && row.item.registrador && row.item.registrador !=''" slot="registrador" slot-scope="row">
                        {{row.item.registrador.nomUsuario}} {{row.item.registrador.appUsuario}}
                    </template>
                    <template slot="fregistro" slot-scope="row">
                        {{ row.item.created_at | moment('D/M/Y') }}
                    </template>
                    <template slot="fpago" slot-scope="row">
                        {{ row.item.fechaPago | moment('D/M/Y') }}
                    </template>
                    <template slot="importe" slot-scope="row">
                        <template v-if="row.item.tipoMoneda == 'PEN'">
                            S/ {{ row.item.importePagado }}
                        </template>
                        <template v-else-if="row.item.tipoMoneda == 'USD'">
                            $ {{ row.item.importePagado }}
                        </template>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card>
                            {{ row.item.observaciones }} 
                        </b-card>
                    </template>
                </b-table>
                 </div>
            </div>
            <div slot="modal-footer" class="w-100 text-right">
                <template v-if="viewbuttonback">
                    <b-button size="sm" class="mr-4" variant="warning" @click="regresarListaPagos()"><i class="fa fa-hand-point-left"> Atras</i></b-button>
                    <b-button size="sm" class="mr-4" variant="primary" v-if="!actualizandopago" @click="pagoDeuda(2)"><i class="fa fa-sync-alt"> Actualizar</i></b-button>
                    <b-button size="sm" class="mr-4" variant="secondary" v-else><i class="fa fa-spin fa-spinner"></i> Actualizando</b-button>
                </template> 
                <b-btn size="sm" variant="danger" @click="cerrarlistapagos"> Cerrar</b-btn>
            </div>
        </b-modal>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import downloadexcel from "vue-json-excel";
import { FormaPago } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
import Datepicker from 'vuejs-datepicker'
    export default {
        name: 'EstadoCuenta',
        components: {
            downloadexcel,
            Datepicker
        },
        props: ['datos','rucCobranza'],
        data: () => {
            return {
                tipo: 0,
                cargando: false,
                receptor: '',
                busy: false,
                consolidadosxpagar: [],
                consolidadospagados: [],
                consolidados_fields: [
                    {key: 'antiguedad', label: ''},
                    {key: 'serie', label: 'Serie', sortable: true},
                    {key: 'numero', label: 'Numero', sortable: false},
                    {key: 'emision', label: 'Emision', sortable: false},
                    {key: 'vencimiento', label: 'Vencimiento', sortable: false},
                    {key: 'numOperacion', label: 'Num.Operación', sortable: false},
                    {key: 'fechaPago', label: 'Fecha Pago', sortable: false},
                    {key: 'tiempo', label: 'Tiempo', sortable: false},
                    {key: 'deudatotalSoles', label: 'Total S/', sortable: true, _showDetails: false},
                    {key: 'parcialsoles', label: 'Parcial S/', sortable: true, _showDetails: false},
                    {key: 'deudapagadasoles', label: 'Deuda S/', sortable: true, _showDetails: false},
                    {key: 'deudatotalDolares', label: 'Total US$', sortable: true, _showDetails: false},
                    {key: 'parcialdolares', label: 'Parcial US$', sortable: true, _showDetails: false},
                    {key: 'deudapagadaDolares', label: 'Deuda US$', sortable: true, _showDetails: false},
                    {key: 'acciones', label: 'Acciones'}
                ],
                pagos_fields: [
                    {key: 'registrador',label:'Nombre Usuario'},
                    {key: 'fregistro', label: 'Fecha de Registro', sortable: true},
                    {key: 'fpago', label: 'Fecha de Pago', sortable: true},
                    {key: 'importe', label: 'Importe', sortable: true},
                    {key: 'acciones', label: 'Acciones', sortable: true}
                ],
                pagos_fields2: [
                    {key: 'fregistro', label: 'Fecha de Registro', sortable: true},
                    {key: 'fpago', label: 'Fecha de Pago', sortable: true},
                    {key: 'importe', label: 'Importe', sortable: true},
                ],
                pago: {},
                detallepagos_fields: [ 
                    {key: 'serie', label: 'Serie', sortable: true},
                    {key: 'numero', label: 'Numero', sortable: true},
                    {key: 'totalsoles', label: 'Total S/', sortable: true},
                    {key: 'pagadosoles', label: 'Debe S/', sortable: true},
                    {key: 'totaldolares', label: 'Total USD', sortable: true},
                    {key: 'pagadodolares', label: 'Debe USD', sortable: true},
                ],
                listaitems_fields: [
                    { key: "index" },
                    { key: "codigoProducto", label: "Codigo", sorteable: true },
                    { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
                    { key: "descripcion", label: "Descripción", sorteable: true },
                    { key: "cantidad", label: "Cantidad", sorteable: true },
                    { key: "baseAfectacionIgv", label: "Valor Total", sorteable: true },
                    { key: "montoAfectacionIgv", label: "IGV", sorteable: true },
                    { key: "descuento", label: "Descuento", sorteable: true },
                    { key: "valorVenta", label: "Precio Total", sorteable: true }
                ],
                importe: '',
                receiver: {},
                listaPagos: [],
                cargandopagos: false,
                editando: false,
                titlepagos: 'Listar Pagos',
                listarpagos: false,
                viewbuttonback: false,
                formaPago: FormaPago,
                tipoMoneda: TipoMoneda,
                detallesCuentaAprobada: null,
                listaBancos: [],
                currentdate: '',
                actualizandopago: false,
                cargandoBancos: false,
                banco: null,
                fpago: '',
                editbank: true,
                refreshpago: false,
                pdfobject: '',
                cargandopdf2: false,
                previewmodal: false,
                registrarpago: false,
                formadepago: {
                    codigo: '000',
                    nombre: 'Elige Forma de Pago'
                },
                tipodemoneda: {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                numerooperacion: '',
                observaciones: '',
                sendpago: false,
                filaActual: {},
                registropagotipo: 0,
                idReceptor: '',
                previacorreo:false,
                recipients: "",
                sendcorreo: false,
                ncpagos:[],
                reciveEmail:[],
                customers:[],
                mostraremail: true,
                nivelusuario:false,
                user:'',
                unoDieciocho:1.18,
                ceroDieciocho:0.18,
                dieciocho:18,
                unoUno:1.105,
                ceroUno:0.105,
                diez:10.5,
                total: 0.0,
                desde: 0.0,
                hasta: 0.0,
                currentPage: 1,
                limit: 500,
                orden: "desc",
            }      
        },
        mounted() {
            this.initDates();
            this.listTerceros();
            this.rangouser();
            this.capturaRUC();
        },
        watch: {
            receptor: function () {
                if(this.receptor.length == 0){
                    this.consolidadosxpagar = [],
                    this.consolidadospagados = [],
                    this.receiver = {}
                }
            }
        },
        methods: {
            mostrarDetalles: function(row, index) {
                console.log('Fila: '+row)
                console.log('Indice: '+index)
                if (row.detailsShowing) {
                    row.toggleDetails();
                    this.consolidadosxpagar[index].mostrardetalles = false;
                } else {
                    this.consolidadosxpagar[index].mostrardetalles = true;
                    this.consolidadosxpagar[index].loading = true;
                    if (this.consolidadosxpagar[index].detalles.length == 0) {
                    setTimeout(() => this.detallesDocumento(row, index), 10);
                    } else {
                    this.consolidadosxpagar[index].loading = false;
                    row.toggleDetails();
                    }
                }
            },
            detallesDocumento: function(row, index) {
                axios
                    .post(process.env.VUE_APP_API_URL + "facturas/items", {
                    token: this.$store.getters.userToken,
                    idfac: row.item.idDocumento
                    })
                    .then(response =>(
                    this.parseDetallesDocumento(response.data.response, row, index)
                    ))
                    .catch(error => (this.consolidadosxpagar[index].mostrardetalles = false));
            },            
            parseDetallesDocumento: function(value, row, index) {       
                this.consolidadosxpagar[index].detalles = [];
                for (let i = 0; i < value.length; i++) {
                    value[i].moneda = row.item.tipoMoneda;
                    this.consolidadosxpagar[index].detalles.push(value[i]);
                }
                this.consolidadosxpagar[index].loading = false;
                // this.invoices[index].mostrardetalles = false
                if (value.length > 0) {
                    row.toggleDetails();
                    }
            },
//INICIO DETALLES PAGADOS
            mostrarDetallesPagados(row, index){
                  if (row.detailsShowing) {
                    row.toggleDetails();
                    this.consolidadospagados[index].mostrarDetallesPagados = false;
                } else {
                    this.consolidadospagados[index].mostrarDetallesPagados = true;
                    this.consolidadospagados[index].loading = true;
                    if (this.consolidadospagados[index].detalles.length == 0) {
                    setTimeout(() => this.detailPagada(row, index), 10);
                    } else {
                    this.consolidadospagados[index].loading = false;
                    row.toggleDetails();
                    }
                }             
            },
            detailPagada: function(row, index) {
                axios
                    .post(process.env.VUE_APP_API_URL + "facturas/items", {
                    token: this.$store.getters.userToken,
                    idfac: row.item.idDocumento
                    })
                    .then(response =>(
                    this.detailsPagados(response.data.response, row,index)
                    ))
                    .catch(error => (this.consolidadosxpagar[index].mostrardetalles = false));
            }, 
             detailsPagados: function(value, row, index) {
                    this.consolidadospagados[index].detalles = [];
                for (let i = 0; i < value.length; i++) {
                    value[i].moneda = row.item.tipoMoneda;
                    this.consolidadospagados[index].detalles.push(value[i]);
                }
                this.consolidadospagados[index].loading = false;
                // this.invoices[index].mostrardetalles = false
                if (value.length > 0) {
                    row.toggleDetails();
                }
            },
//FIN DETALLES PAGADOS
            editBank: function () {
                this.editbank = false
            },
            validFormularioPago: function () {
                if(this.importe != '' && this.tipodemoneda.codigo != '000' && this.formadepago.codigo != '000' && this.numerooperacion !=''){
                    return false
                }else{
                    return true
                }
            },
            getDocumento: function (row, tipo) {
                if(row){
                    this.filaActual = row,
                    this.registropagotipo = tipo
                    this.idReceptor = row.item.idDocumentoCredito
                }else {this.idReceptor = ''}
                if(tipo === 1){
                    this.tipodemoneda = this.loadMoneda(row.item)
                    this.listBanks()
                }else if(tipo === 2){
                    this.watchPayment(row)
                }
            },
            viewPdf: function (data) {
                this.previewmodal = true,
                this.pdfobject = '',
                this.cargandopdf2 = true
                axios
                .post(process.env.VUE_APP_API_URL + 'facturas/pdf',{
                token: this.$store.getters.userToken,
                id: data.idDocumento
                })
                .then(response => (
                this.pdfobject = response.data.base64,
                this.cargandopdf2 = false
                // this.previewmodal = false
                ))
                .catch(error => {
                    this.cargandopdf2 = false,
                    this.$snotify.warning('Ups hubo un error al descargar el PDF, por favor intentenlo mas tarde','Advertencia'),
                    this.previewmodal = false
                })
            },
            pagoDeuda: function (tipo) {
                let ruta = ''
                let id = ''
                let importe = ''
                let fechapago = ''
                let infobanco = ''
                let paquete = {}
                this.actualizandopago = true
                this.sendpago = true
                this.banco == null ? infobanco = '': infobanco = this.banco.idInformacionBanco
                this.fpago == '' ? fechapago = this.$moment().format('YYYY-MM-DD HH:MM:SS'): fechapago = this.$moment(this.fpago).format('YYYY-MM-DD HH:MM:SS')
                paquete.token = this.$store.getters.userToken
                if(tipo===1){
                    ruta = 'documentoscredito/emisor/regularizar'                
                    paquete.id = String(this.idReceptor)
                    paquete.importepagar = this.importe
                    paquete.tipomoneda = this.tipodemoneda.codigo
                    paquete.formapago = this.formadepago.codigo
                    paquete.fechapago = fechapago
                    paquete.numerooperacion = this.numerooperacion
                    paquete.idinformacionbanco = infobanco
                    paquete.observaciones = this.observaciones
                }else if(tipo===2){
                    ruta = 'documentoscredito/emisor/regularizar/editar'
                    paquete.id = this.pago.idDocumentoCreditoPago
                    paquete.importePagado = this.importe
                    paquete.formaPago = this.formadepago.codigo
                    paquete.fechaPago = fechapago
                    paquete.numeroOperacion = this.numerooperacion
                    paquete.idInformacionBancaria = infobanco
                    paquete.observaciones = this.observaciones
                    this.refreshpago = true
                }
                axios
                .post(process.env.VUE_APP_API_URL + ruta, paquete)
                .then(response => (
                    this.actualizandopago = false,
                    this.sendpago = false,
                    this.registrarpago = false,
                    this.listarpagos = false,
                    this.viewbuttonback = false,
                    this.$snotify.success(response.data.msg,'Exito'),
                    this.listPagadas(),
                    this.initPago(tipo)
                ))  
                .catch(error => (
                    this.actualizandopago = false,
                    this.sendpago = false,
                    this.$snotify.error(error.response.data.msg,'Error')
                )) 
            },
            initPago: function (tipo) {
                this.idReceptor = ''
                this.importe = ''
                this.tipodemoneda = {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                this.formadepago = {
                    codigo: '000',
                    nombre: 'Elige Forma de Pago'
                },
                this.observaciones = ''
            },
            customFormatter: function (date) {
                return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            },
            initDates: function () {   
                this.fpago =  this.$moment().format('YYYY-MM-DD HH:mm:ss')
                this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
                if(this.datos.tipo==2){
                    this.tipo = 2
                    this.listPagadas()
                }else{
                    this.tipo = 1
                }
            },
            listBanks: function () {
                this.cargandoBancos = true
                axios
                .post(process.env.VUE_APP_API_URL + 'infobanco/listar',{
                    token: this.$store.getters.userToken,
                    limit: '10',
                    order: 'desc'
                })
                .then(response => (
                    this.cargandoBancos = false,
                    this.listaBancos = response.data.data
                ))
                .catch(error => (
                    this.cargandoBancos = false
                ))
            },
            deletePago: function (row) {
                this.$swal({
                title: 'Eliminar Pago',
                text: 'Seguro de eliminar este pago ???',
                icon: 'warning',
                buttons: true,
                dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                        this.listarpagos = false
                        axios
                        .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/regularizar/eliminar',{
                            token: this.$store.getters.userToken,
                            id: row.item.idDocumentoCreditoPago
                        })
                        .then(response => (
                            this.$snotify.success(response.data.msg,'Exito'),
                            this.listPagadas()
                        ))
                        .catch(error => (
                            this.$snotify.error('Ups, Hubo un error intentelo luego!','Error')
                        ))
                    }
                })
            },
            editPago: function (data) {
                this.titlepagos = 'Editando Pago'
                this.viewbuttonback = true
                let fopago = {}
                this.pago = data.item,
                this.formaPago.forEach(function(element) {
                    if(element.codigo == data.item.formaPago){
                        fopago.codigo = element.codigo
                        fopago.nombre = element.nombre
                    }
                }),
                this.formadepago = fopago
                this.tipodemoneda = this.loadMoneda(data.item)
                this.importe = this.pago.importePagado
                this.numerooperacion = this.pago.numeroOperacion
                this.fpago = this.pago.fechaPago
                this.observaciones = this.pago.observaciones
                this.editando = true
                this.loadBanks()
            },
            loadBanks: function () {
                if(this.listaBancos.length == 0){
                    this.listBanks()
                }
            },
            loadMoneda: function (data) {
                let timoneda = {}
                this.tipoMoneda.forEach(function(element) {
                    if(element.codigo == data.tipoMoneda){
                        timoneda.id = element.id
                        timoneda.codigo = element.codigo
                        timoneda.descripcion = element.descripcion
                        timoneda.simbolo = element.simbolo
                    }
                })
                return timoneda
            },
            cerrarlistapagos: function () {
                this.listarpagos = false
            },
            regresarListaPagos: function () {
                this.titlepagos = 'Listar Pagos'
                this.editando = false
                this.editbank = true
                this.viewbuttonback = false
            },
            watchPayment: function (row) {
                this.listaPagos = []
                this.cargandopagos = true
                this.editando = false
                 axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/emisor/regularizar/listar',{
                    token: this.$store.getters.userToken,
                    id: row.item.idDocumentoCredito
                })
                .then(response => (
                    this.cargandopagos = false,
                    this.respuestaListaPago(response.data)
                ))  
                .catch(error => (
                    this.cargandopagos = false
                    // this.$snotify.error(error.response.data.message,'Error')
                )) 
            },
            respuestaListaPago: function (respuesta) {
                if(respuesta.success == 0){
                    this.listarpagos = false,
                    this.$snotify.warning(respuesta.msg,'Importante')
                }else if(respuesta.success == 1){
                    this.listaPagos = respuesta.pagos
                    this.ncpagos = respuesta.notas
                }
            },
            checkPagadas: function () {
                if(this.receptor != ''){
                    return false
                }else{
                    return true
                }
            },
            listPagadas() {
                this.cargando = true
                this.busy = true
                let receptor = ''
                this.datos.tipo==1 ? receptor = this.receptor: receptor = this.datos.documento
                axios
                .post(process.env.VUE_APP_API_URL + 'documentoscredito/reporte/emitidos',{
                    token: this.$store.getters.userToken,
                    receptor: receptor,
                    page: this.currentPage,
                    order: this.orden,
                    limit: this.limit
                })
                .then(response => (
                    (this.total = response.data.porpagar.total),
                    (this.desde = response.data.porpagar.from),
                    (this.hasta = response.data.porpagar.to),
                    this.cargando = false,
                    this.busy = false,
                    this.intercept(response.data)
                ))
                .catch(error => (
                    this.cargando = false,
                    this.busy = false
                ))
            },
            intercept: function (data) {
                if(data.success == 1){
                    this.consolidadospagados = data.pagado.data
                    this.consolidadosxpagar = data.porpagar.data
                    if(this.consolidadospagados.length > 0){
                        this.receiver = this.consolidadospagados[0].receiver
                    }else if(this.consolidadosxpagar.length > 0){
                        this.receiver = this.consolidadosxpagar[0].receiver
                    }
                }else{
                    this.$snotify.warning('No se encontraron resultados!', 'Atención')
                }
            },
            setTicket(data){
                this.ticket = data
                this.reciveEmail = []
                this.listTerceros();
                let valordata = data
                let pasandoCorreoTerceros = {}
                this.customers.forEach(function(element){
                    if(valordata.receiver.idReceptor == element.documento){
                        pasandoCorreoTerceros = element.emailEnvio
                    }      
                })
                this.reciveEmail = pasandoCorreoTerceros;
                if(this.reciveEmail.length > 0){
                    this.mostraremail = false;
                }else{
                    this.mostraremail = true;
                }
            },
            borrarCorreo(index){
                this.reciveEmail.splice(index, 1)
                if(this.reciveEmail.length > 0){
                    this.mostraremail = false;
                }else{
                    this.mostraremail = true;
                }
            },
            listTerceros: function() {
                axios
                .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
                    token: this.$store.getters.userToken,
                    page: this.currentPageTerceros,
                    order: this.ordenTerceros
                })
                .then(response =>(
                    this.customers = response.data
                ))
                .catch(error => (
                    console.log(error)
                ))
            },
            enviarEmail: function(data) {
                for (let i = 0; i < this.reciveEmail.length; i++) {
                        this.reciveEmail[i] + ","
                    }
                let cadena = this.reciveEmail.join(",");
                if(this.recipients !=''){
                        this.sendMail(data);  
                    } 
                this.previacorreo = true;
                this.sendcorreo = true;
                let ruta;
                if(data.tipoDocumento == "01"){
                    ruta = "facturas/mail"
                }else if(data.tipoDocumento == "03"){
                    ruta = "boletas/mail"
                }
            axios
            .post(process.env.VUE_APP_API_URL + ruta, {
                token: this.$store.getters.userToken,
                id: data.idDocumento,
                mail: cadena
                })
            .then(
                response => (
                (this.previacorreo = false),
                (this.sendcorreo = false),
                this.alertaenvio(response.data.msg)
            ))
            .catch(
                 error => (
                (this.previacorreo = false),
                (this.sendcorreo = false),
                this.$snotify.error(error.response.data.response, "Error")
            ));
            },
            alertaenvio(data){
                if(this.recipients == ''){
                    this.$snotify.success(data, "Exito")
                }
            },
            sendMail: function(data) {
                this.previacorreo = true;
                this.sendcorreo = true;
                let ruta;
                if(data.tipoDocumento == "01"){
                    ruta = "facturas/mail"
                }else if(data.tipoDocumento == "03"){
                    ruta = "boletas/mail"
                }
            axios
            .post(process.env.VUE_APP_API_URL + ruta, {
                token: this.$store.getters.userToken,
                id: data.idDocumento,
                mail: this.recipients
                })
            .then(
                response => (
                (this.previacorreo = false),
                (this.sendcorreo = false),
                this.$snotify.success(response.data.msg, "Exito")
            ))
            .catch(
                 error => (
                (this.previacorreo = false),
                (this.sendcorreo = false),
                this.$snotify.error(error.response.data.response, "Error")
            ));
            },
            rowClass(item, type) {
                if (!item || type !== 'row') return
                if (item.tieneNota === 1) return 'table-danger'
            },
            rangouser(){
                    this.user =  this.$store.getters.userData.perfil.rolUsuario
                    if(this.user == 3){
                        this.nivelusuario = false
                    }else{
                        this.nivelusuario = true;
                    }
                },
            capturaRUC(){
                if(this.rucCobranza!=''){
                    this.receptor = this.rucCobranza;
                }
                if(this.receptor !='' && this.receptor.length == 11 || this.receptor !='' && this.receptor.length == 8){
                        this.listPagadas();
                }
            }    
        }
    }
</script>

<style>
.cursor{
  cursor: pointer;
}
</style>